import React, {Component} from 'react';
import {Button, Grid} from '@material-ui/core';
import {Delete, Cancel} from '@material-ui/icons';

class DeleteBtn extends Component {

	render() {
		return (
			<Button variant="contained" onClick={this.props.onClick} style={{...this.props.style, height: "3rem", background: this.props.disabled ? "" : "#d9534f", color: "white", fontSize: "1rem", lineHeight: "0"}}>
				<Grid container item justify="space-between" alignItems="center">
					{this.props.delete && (<Delete />)}
					{!this.props.delete && (<Cancel />)}
					<span style={{margin: "0 0.5rem"}}>{this.props.text}</span>
				</Grid>
			</Button>
		);
	}
}

export default DeleteBtn;
